const lazy = Array.from(document.querySelectorAll("[data-lazy]"));
const backgrounds = Array.from(document.querySelectorAll(".background-lazy"));

let observer;

function handleIntesect(item) {
    if (item.isIntersecting) {
        const { target } = item;
        const { lazy } = target.dataset;

        if (lazy) {
            if (item.target.getAttribute("src")) {
                item.target.setAttribute("src", lazy);
            }

            if (lazy.substr(0,3) === 'url') {
                item.target.setAttribute(
                    "style",
                    `--background-image: ${lazy}`
                );
            }

            item.target.removeAttribute("data-lazy");
        }
    }
}

function handleObserver(entries) {
    entries.forEach(handleIntesect);
}

function setup(el) {
    if (!observer) return;

    observer.observe(el);
}

function init() {
    if (!lazy && !backdropHeros) return;

    const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.4,
    };

    observer = new IntersectionObserver(handleObserver, options);

    const all = [...lazy, ...backgrounds];
    all.forEach(setup);
}

init();
